import { Link } from 'react-router-dom';

import Logo from './Logo';

const LINKS = [
  { to: '/faq', label: 'FAQ' },
  { to: '/terms', label: 'Terms' },
  { to: '/privacy', label: 'Privacy' },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-32 border-t border-line bg-paper">
      <div className="container-page flex flex-col items-start gap-8 py-12 md:py-16">
        <div className="flex flex-col gap-3">
          <Logo height={28} />
          <p className="m-0 text-sm text-ink-3">
            One question a day, just for the two of you.
          </p>
        </div>

        <nav aria-label="Footer" className="w-full">
          <ul className="flex flex-wrap gap-x-6 gap-y-3">
            {LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  className="text-sm text-ink-2 no-underline hover:text-doodi-coral-deep hover:underline"
                >
                  {l.label}
                </Link>
              </li>
            ))}
            <li>
              <a
                href="mailto:hello@doodi.day"
                className="text-sm text-ink-2 no-underline hover:text-doodi-coral-deep hover:underline"
              >
                Contact
              </a>
            </li>
          </ul>
        </nav>

        <p className="m-0 w-full border-t border-line pt-6 text-xs text-ink-muted">
          © {year} Doodi. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
